import { render, staticRenderFns } from "./ToDoView.vue?vue&type=template&id=76215500&scoped=true&"
import script from "./ToDoView.vue?vue&type=script&lang=js&"
export * from "./ToDoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76215500",
  null
  
)

export default component.exports